import React, { useState } from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Form, Input, InputPicker, SelectPicker } from 'rsuite';
import { titleData, suffixData } from '../../../../fakeapi'
import { PatternFormat } from 'react-number-format';
import RedStar from '../../GenericComponents/RedStar';
import YesNoRadioOption from '../../RadioButton/YesNoRadioOption';
import { getCountries, getStates } from '../../../../services/Shared/codeTable.service'
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import PhoneNumberMask from '../../GenericComponents/PhoneNumberMask';
import TextArea from '../../GenericComponents/TextArea';
import { AccessibleSelectPicker } from '../../GenericComponents/AccessibleComponents';

function PersonalInformation({ isUserEditable, isForApp, isReadOnly, isNonUsBirthState, isPeByComity, showVisaGreenCardError, isExternal }) {
    const [countries, setCountries] = useState([])
    const [states, setStates] = useState([])

    useEffect(() => {
        getCountries().then(setCountries);
        getStates().then(setStates);
    }, [])
    return (
        <Card>
            <Card.Header>

                <Row>
                    <Col lg={6}>
                        <h6>Personal Information</h6>
                    </Col>
                    {(isReadOnly && isUserEditable) &&
                        <Col lg={6}>
                            <Row>
                                <Col lg={9}>
                                    <b style={{ color: "#EB0000" }}>NOTE:</b> By clicking the Update Contact Information button, the Update Contact Information section will open in a new tab. After you save your changes in this new tab, close this tab and refresh your page to continue your application, renewal, or reinstatement.</Col>
                                <Col lg={3}><Button as={Link} to="/individual/contactinformation" variant="dark" target="_blank">
                                    Update Contact Information</Button>
                                </Col>
                            </Row>
                        </Col>
                    }
                </Row>


            </Card.Header>
            <Card.Body>
                {isExternal ? <>
                    {isForApp ?
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            If approved, full name displayed on certificate?
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control readOnly={!isUserEditable} name="certificateName" />
                                </Col>
                            </Row>
                            <Form.HelpText className="d-none">Certificate Name</Form.HelpText>
                        </Form.Group> :
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Name
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control plaintext tabIndex="-1" name="formattedName" />
                                </Col>
                            </Row>
                            <Form.HelpText className="d-none">Formatted Name</Form.HelpText>
                        </Form.Group>
                    }
                    <Form.Group>
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        Maiden Name (if different from last name)
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control plaintext name="maidenName" />
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        Date of Birth (mm/dd/yyyy)&nbsp;<RedStar />
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control name="dateOfBirth" type="date" plaintext tabIndex="-1" />
                            </Col>
                        </Row>
                    </Form.Group>
                </>
                    : <>
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Title&nbsp;<RedStar />
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control
                                        accepter={InputPicker}
                                        placeholder=" "
                                        block
                                        data={titleData}
                                        name="title"
                                        tabIndex="-1"
                                        plaintext />
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            First Name&nbsp;<RedStar />
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control plaintext name="firstName" />
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Middle Name (birth name)
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control plaintext name="middleName" />
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Last Name&nbsp;<RedStar />
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control plaintext name="lastName" />
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Maiden Name (if different from last name)
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control plaintext={isReadOnly} name="maidenName" />
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Suffix
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control
                                        placeholder=" "
                                        block
                                        data={suffixData}
                                        name="suffix"
                                        accepter={InputPicker}
                                        tabIndex="-1"
                                        plaintext />
                                </Col>
                            </Row>
                        </Form.Group>
                        {isForApp &&
                            <Form.Group>
                                <Row>
                                    <Col sm={3}>
                                        <Form.ControlLabel>
                                            <strong>
                                                If approved, full name displayed on certificate?
                                            </strong>
                                        </Form.ControlLabel>
                                    </Col>
                                    <Col sm={9}>
                                        <Form.Control readOnly={!isUserEditable} name="certificateName" />
                                    </Col>
                                    <Form.HelpText className="d-none">If approved, full name displayed on certificate?</Form.HelpText>
                                </Row>
                            </Form.Group>
                        }
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Date of Birth&nbsp;<RedStar />
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control name="dateOfBirth" type="date" plaintext tabIndex="-1" />
                                </Col>
                            </Row>
                        </Form.Group>
                    </>}
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    City of Birth&nbsp;<RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control plaintext name="birthCity" />
                        </Col>
                    </Row>
                </Form.Group>
                <Form.Group>
                    {isNonUsBirthState ?
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        State/Province/Region
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control name="nonUsBirthState" plaintext tabIndex="-1" />
                            </Col>
                        </Row>
                        :
                        <Row>
                            <Col sm={3}>
                                <Form.ControlLabel>
                                    <strong>
                                        State of Birth
                                    </strong>
                                </Form.ControlLabel>
                            </Col>
                            <Col sm={9}>
                                <Form.Control
                                    accepter={InputPicker}
                                    placeholder=""
                                    block
                                    data={states}
                                    name="birthState"
                                    searchBy={(userInput, label, dataItem) => { if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput) return true; }}
                                    tabIndex="-1"
                                    plaintext />
                            </Col>
                        </Row>
                    }
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Country of Birth&nbsp;<RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control
                                accepter={InputPicker}
                                placeholder="Please Select"
                                block
                                data={countries}
                                name="birthCountry"
                                tabIndex="-1"
                                plaintext />
                        </Col>
                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>SSN&nbsp;<RedStar /></strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control plaintext name="federalId" />
                        </Col>
                    </Row>
                </Form.Group>

                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>Email Address&nbsp;<RedStar /></strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control plaintext={isReadOnly} name="primaryEmail" />
                        </Col>
                        <Form.HelpText className="d-none">Email Address</Form.HelpText>
                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    MyNCEES#
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            {
                                isReadOnly
                                    ?
                                    <Form.Control
                                        accepter={PatternFormat}
                                        name="myNceesNumber"
                                        plaintext
                                        format="##-###-##"
                                        displayType={'text'} />
                                    :
                                    <Form.Control
                                        accepter={PhoneNumberMask}
                                        name="myNceesNumber"
                                        format="##-###-##"
                                        mask="_" />
                            }
                        </Col>
                    </Row>
                    <Form.HelpText className="d-none">MyNCEES#</Form.HelpText>
                </Form.Group>

                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Alternate Email Address
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control plaintext={isReadOnly} name="altEmail" />
                        </Col>
                        <Form.HelpText className="d-none">Alternate Email Address</Form.HelpText>
                    </Row>
                </Form.Group>



                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Mobile Phone&nbsp;<RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            {
                                isReadOnly
                                    ?
                                    <Form.Control
                                        accepter={PatternFormat}
                                        name="cellPhoneNum"
                                        plaintext
                                        format="(###) ###-####"
                                        displayType={'text'} />
                                    :
                                    <Form.Control
                                        accepter={PhoneNumberMask}
                                        name="cellPhoneNum"
                                        format="(###) ###-####"
                                        mask="_" />
                            }
                        </Col>
                    </Row>
                    <Form.HelpText className="d-none">Mobile Phone Number</Form.HelpText>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Work Phone
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            {
                                isReadOnly
                                    ?
                                    <Form.Control
                                        accepter={PatternFormat}
                                        name="workPhoneNum"
                                        plaintext
                                        format="(###) ###-####"
                                        displayType={'text'} />
                                    :
                                    <Form.Control
                                        accepter={PhoneNumberMask}
                                        name="workPhoneNum"
                                        format="(###) ###-####"
                                        mask="_" />
                            }
                        </Col>
                    </Row>
                    <Form.HelpText className="d-none">Work Phone Number</Form.HelpText>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Home Phone
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            {
                                isReadOnly
                                    ?
                                    <Form.Control
                                        accepter={PatternFormat}
                                        name="homePhoneNum"
                                        plaintext
                                        format="(###) ###-####"
                                        displayType={'text'} />
                                    :
                                    <Form.Control
                                        accepter={PhoneNumberMask}
                                        name="homePhoneNum"
                                        format="(###) ###-####"
                                        mask="_" />
                            }
                        </Col>
                    </Row>
                    <Form.HelpText className="d-none">Home Phone Number</Form.HelpText>
                </Form.Group>


                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Are you a U.S. Citizen?&nbsp;<RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <YesNoRadioOption plaintext radioName="isUsCitizen" />
                        </Col>
                    </Row>
                    <Form.HelpText className="d-none">U.S Citizen Verification</Form.HelpText>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Visa/Green Card No.
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control
                                plaintext={isReadOnly}
                                errorMessage={showVisaGreenCardError ? "This field is required." : ""}
                                name="visaGreenCardNumber" />
                            <Form.HelpText className="d-none">Visa/Green Card No.</Form.HelpText>

                        </Col>
                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    If No, what country?
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control
                                accepter={InputPicker}
                                placeholder="-"
                                block
                                data={countries}
                                name="citizenshipCountry"
                                tabIndex="-1"
                                plaintext />
                            <Form.HelpText className="d-none">If No, what country?</Form.HelpText>

                        </Col>
                    </Row>
                </Form.Group>
                {isPeByComity &&
                    <>
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Active military stationed in Louisiana
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <YesNoRadioOption isReadOnly={!isUserEditable} radioName="isActiveMilitary" />
                                </Col>
                                <Form.HelpText className="d-none">Active military stationed in Louisiana</Form.HelpText>

                            </Row>
                        </Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            I am stationed at (select one)
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control
                                        accepter={AccessibleSelectPicker}
                                        placeholder="Select Station"
                                        searchable={false}
                                        block
                                        readOnly={!isUserEditable}
                                        data={[{ "label": "Camp Beauregard", "value": "Camp Beauregard" }, { "label": "Fort Polk", "value": "Fort Polk" }, { "label": "Barksdale Air Force Base", "value": "Barksdale Air Force Base" }]}
                                        name="baseStationed" />
                                </Col>
                                <Form.HelpText className="d-none">I am stationed at (select one)</Form.HelpText>

                            </Row>
                        </Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            Spouse of active military stationed in Louisiana
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <YesNoRadioOption isReadOnly={!isUserEditable} radioName="isActiveMilitarySpouse" />
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group>
                            <Row>
                                <Col sm={3}>
                                    <Form.ControlLabel>
                                        <strong>
                                            They are stationed at (select one)
                                        </strong>
                                    </Form.ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Form.Control
                                        accepter={AccessibleSelectPicker}
                                        placeholder="Select Station"
                                        searchable={false}
                                        block
                                        readOnly={!isUserEditable}
                                        data={[{ "label": "Camp Beauregard", "value": "Camp Beauregard" }, { "label": "Fort Polk", "value": "Fort Polk" }, { "label": "Barksdale Air Force Base", "value": "Barksdale Air Force Base" }]}
                                        name="spouseBaseStationed" />
                                </Col>
                                <Form.HelpText className="d-none">They are stationed at (select one)</Form.HelpText>
                            </Row>
                        </Form.Group>
                    </>
                }
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Additional Information
                                </strong><br />
                                <em>Max 1000 characters including spaces</em>

                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control
                                accepter={TextArea}
                                rows={5}
                                name="additionalInformation"
                                plaintext={isReadOnly}
                                maxLength={1000} />
                        </Col>
                        <Form.HelpText className="d-none"> Additional Information</Form.HelpText>

                    </Row>
                </Form.Group>
            </Card.Body>
        </Card>
    );
}
export default PersonalInformation;